import { hexWithOpacity } from 'common/utils';

export const colors = {
  topBackground: '#EEF5FF',
  background: '#FFFFFF',
  text: '#142C52',
  primary: '#073B70',
  secondary: '#7B88A8',
  warning: '#FFA500',
  success: '#00C650',
  error: '#F7403C',
  card: '#f9f9f9',
  border: hexWithOpacity('#60709F', 0.15),
  pureBorder: '#60709F',
  white: '#ffffff',
  black: '#000000',
  link: '#1877f2',
  dark: '#142C52',
  gray: '#6B7F94',
  lightgray: '#B8C1CC',
  inputBackground: hexWithOpacity('#60709F', 0.10),
  neutral: '#142C52',
  transparent: 'transparent',
  appeal: '#198CFF',
  delete: '#CE2C60',
  edit: '#54A6FF',
  view: '#2B7F75',
  notes: '#f65c5c',
  itemBorder: hexWithOpacity('#60709F', 0.3),
  skeleton: hexWithOpacity('#7B88A8', 0.2),
  avatarBg: hexWithOpacity('#073B70', 0.2),
} as const;

/**
 * Union of all valid color keys
 */
export type ColorIntent = keyof typeof colors;
